import React from 'react';
import { Field, useFormikContext } from 'formik';
import { Fields, Columns } from 'modules/af_cm_ui_kit/components';
import { VARIANTS_TYPES } from 'modules/af_cm_ui_kit/components/TextField/variants.types';
import { FIELDS, FIELDS_QUESTIONS, FormValues } from '../Form/Form.types';
import { Props } from './LifeEvents.types';
import { getIsRetired } from '../Form/Form';

const Current: React.FC<Props> = ({ prefix }) => {
  const { values } = useFormikContext<FormValues>();

  const isRetired = getIsRetired(values, prefix.split('.')[0]);

  return (
    <>
      <Field
        component={Fields.Text}
        title={FIELDS_QUESTIONS.INVESTMENT_PORTFOLIO_VALUE}
        name={`${prefix}.${FIELDS.INVESTMENT_PORTFOLIO_VALUE}`}
        variant={VARIANTS_TYPES.CURRENCY}
      />
      <Field
        component={Fields.Text}
        title={FIELDS_QUESTIONS.VALUE_OF_ASSET_AT_RETIREMENT}
        name={`${prefix}.${FIELDS.VALUE_OF_ASSET_AT_RETIREMENT}`}
        variant={VARIANTS_TYPES.CURRENCY}
        disabled={isRetired}
      />
      <Field
        component={Fields.Text}
        title={FIELDS_QUESTIONS.MORTGAGE_PROTECTION_MONTHLY_PAYMENT}
        name={`${prefix}.${FIELDS.MORTGAGE_PROTECTION_MONTHLY_PAYMENT}`}
        variant={VARIANTS_TYPES.CURRENCY}
      />
      <Columns spacing={4}>
        <Field
          component={Fields.Text}
          title={FIELDS_QUESTIONS.LIFE_ASSURANCE_LUMP_SUM}
          name={`${prefix}.${FIELDS.LIFE_INSURANCE_LUMP_SUM}`}
          variant={VARIANTS_TYPES.CURRENCY}
        />
        <Field
          component={Fields.Text}
          title={FIELDS_QUESTIONS.LIFE_ASSURANCE_PREMIUM}
          name={`${prefix}.${FIELDS.LIFE_INSURANCE_PREMIUM}`}
          variant={VARIANTS_TYPES.CURRENCY}
        />
      </Columns>
    </>
  );
};

export default Current;
